import Vue from "modules/vue_twemoji";
import VueI18n from "vue-i18n";
import QuestEvaluation from "components/quest-evaluation";
import { i18n } from "modules/i18n";

Vue.use(VueI18n);

const $questEvaluationContainer = document.querySelector(".js-quest-evaluation");

if($questEvaluationContainer) {
  new Vue({
    i18n,
    el: $questEvaluationContainer,
    render: h => h(QuestEvaluation)
  });
}
